module.exports = __webpack_public_path__ + "static/media/industries-friction-s.3098d6d5.webp";